import BranchBaseController from '../common/branch.base.controller'

class BranchCreateController extends BranchBaseController {
	 /*@ngInject*/
	constructor(Auth, $state, User, BranchService, Modal, $translate, $stateParams ,WindowService) {
	
		super(Auth, $state, User, BranchService, Modal, $translate)

		this.WindowService = WindowService

		this.model.id=''
		this.model.description=''
		this.model.windows = [];
		this.model.businessDayMon = false;
		this.model.businessDayTue = false;
		this.model.businessDayWed = false;
		this.model.businessDayThu = false;
		this.model.businessDayFri = false;
		this.model.businessDaySat = false;
		this.model.businessDaySun = false;
		this.model.businessDayHol = false;

		this.businessDays = [
			{ label: 'Monday', model: 'businessDayMon' },
			{ label: 'Tuesday', model: 'businessDayTue' },
			{ label: 'Wednesday', model: 'businessDayWed' },
			{ label: 'Thursday', model: 'businessDayThu' },
			{ label: 'Friday', model: 'businessDayFri' },
			{ label: 'Saturday', model: 'businessDaySat' },
			{ label: 'Sunday', model: 'businessDaySun' },
			{ label: 'Holiday', model: 'businessDayHol' }
		];
		this.isDaySelected = (day) => this.model[day.model];
		this.toggleDay = (day) => { this.model[day.model] = !this.model[day.model]; };
	}

	addWindow() {
		this.model.windows.push({
			expand: true,
			id: null,
			description: null,
			allowCash: true,
			allowCoin: false
		});
	}

	toggleExpand(window) {
		window.expand = !window.expand;
	}

	deleteWindow(index) {
		this.Modal.confirm({
			header: this.$translate.instant('branch.confirm'),
			message: this.$translate.instant('branch.confirm_delete_message'),
			callback: ({
				modal,
				$scope
			}) => {
				this.model.windows.splice(index, 1);
				modal.close()
			},
			negative: ({
				modal,
				$scope
			}) => {
				modal.close()
			},
			type: 'primary',
			buttons: ['common.yes', 'common.no']
		})
	}

	reset() {
		for (let key in this.model) {
			this.model[key]=''
	  	}
	  	this.model.windows = [];
		this.clearErrors()
	}

	submit(evt) {
		this.loading = true
		this.Service.create({
			id: this.model.id,
			description: this.model.description,
			windows: this.model.windows,
			businessDayMon: this.model.businessDayMon,
			businessDayTue: this.model.businessDayTue,
			businessDayWed: this.model.businessDayWed,
			businessDayThu: this.model.businessDayThu,
			businessDayFri: this.model.businessDayFri,
			businessDaySat: this.model.businessDaySat,
			businessDaySun: this.model.businessDaySun,
			businessDayHol: this.model.businessDayHol
		})
		.then((data) => {
			this.loading = false
			this.askCreate()
		})
		.catch((err) => {
			this.loading = false
			err.data.errors.map((e) => {
				this.errorMessage += e.message + '<br/>'
			})
		})
	}
}

export default BranchCreateController;



// WEBPACK FOOTER //
// ./client/app/components/branch/create/branch.create.controller.js